import { BorderRadius, Color, FontWeight, Spacing, zIndex } from '@billy/design-system'
import { css } from '@emotion/core'

export const getHeaderCellStyles = () => {
  return css`
    width: 160px;
    padding: ${Spacing.S16} ${Spacing.S24};

    background-color: ${Color.White};
    text-align: right;
    align-content: center;
    font-weight: ${FontWeight.Bold};

    :first-of-type {
      text-align: left;
      border-top-left-radius: ${BorderRadius.R12};
      min-width: 320px;
      max-width: 320px;
      padding-left: ${Spacing.S40};
      top: 0;
      z-index: ${zIndex.TableStickyHeader};
    }

    :last-of-type {
      border-top-right-radius: ${BorderRadius.R12};
    }
  `
}
